import { useMemo } from "react";
import { m } from "framer-motion";
import cx from "classnames";

import useUpper from "../../hooks/useUpper";
import style from "./Hero.module.css";

const Hero = () => {
  const screen = useUpper();
  const highlightTransition = {
    delay: 1.5,
    duration: 0.6,
    ease: "easeOut",
    opacity: { delay: 1 },
  };
  const highlightWidth = useMemo(() => {
    switch (screen) {
      case "xxs":
        return "220px";
      case "xs":
        return "275px";
      default:
        return "458px";
    }
  }, [screen]);

  const headerVariants = {
    start: { opacity: 0, scale: 0 },
    end: { opacity: 1, scale: 1, transition: { delay: 1, duration: 0.5 } },
  };

  return (
    <div className="pt-16 sm:pt-24 pb-8 flex flex-col items-center relative">
      <div
        className={cx("mb-4 mx-auto", style.typewriter)}
        style={{ width: "210px" }}
      >
        <h3 className="uppercase text-teal-600 font-medium font-title text-sm tracking-widest relative z-10">
          Fullstack Engineer
        </h3>
      </div>
      <div className="text-center px-4">
        <m.h1
          initial="start"
          animate="end"
          variants={headerVariants}
          className="font-bold text-3xl xs:text-4xl sm:text-6xl relative z-10"
        >
          The kind of code
        </m.h1>
        <div className="inline-flex items-baseline justify-center gap-x-2 mt-2 mb-4">
          <m.h1
            initial="start"
            animate="end"
            variants={headerVariants}
            className="font-bold text-3xl xs:text-4xl sm:text-6xl"
          >
            you
          </m.h1>
          <div className="relative">
            <m.div
              initial={{ opacity: 0, x: 0 }}
              animate={{ opacity: 1, x: highlightWidth }}
              transition={highlightTransition}
              className="absolute top-0 left-0 w-1 h-9 xs:h-11 sm:h-16 bg-green-500 rounded-m"
            >
              <div className="hidden sm:block">
                <m.div
                  className="h-6 relative bottom-5 bg-green-500 rounded-md rounded-bl-none font-bold px-2 text-white text-left overflow-hidden"
                  initial={{ width: 0, opacity: 0 }}
                  animate={{ width: "108px", opacity: 1 }}
                  transition={{
                    delay: 2.5,
                    duration: 0.3,
                    opacity: { duration: 0.1, delay: 2.5 },
                  }}
                >
                  <span className="whitespace-nowrap">Confidently.</span>
                </m.div>
              </div>
            </m.div>
            <m.div
              initial={{ width: 0 }}
              animate={{ width: highlightWidth }}
              transition={highlightTransition}
              className="absolute top-0 left-0 bg-green-500 opacity-30 h-9 xs:h-11 sm:h-16 rounded-xl rounded-r-none"
            />
            <m.h1
              initial="start"
              animate="end"
              variants={headerVariants}
              className="font-bold text-3xl xs:text-4xl sm:text-6xl relative z-10 whitespace-nowrap"
            >
              deploy on Friday
            </m.h1>
          </div>
        </div>
      </div>
      <p className="text-lg sm:text-xl leading-tight tracking-tight font-body w-80 sm:w-[32rem] mx-auto relative z-10 text-center">
        Five years shipping production systems. TypeScript, React, Node, PostgreSQL. Former NASA.
      </p>
    </div>
  );
};

export default Hero;
